import { length, regexp, required } from 'js/utils/Validation/validationRules';

export const FORM_FIELD_PASSPORT_NUMBER = {
    id: 'passportNumber',
    type: 'text',
    name: 'passportNumber',
    placeholder: 'field.passportNumber.placeholder',
    label: 'field.passportNumber.label',
    readOnly: true
};

export const FORM_FIELD_DATE_OF_BIRTH = {
    id: 'birthday',
    type: 'dateOfBirth',
    name: 'birthday',
    placeholder: 'field.birthday.placeholder',
    label: 'field.birthday.label',
    readOnly: true
};

export const FORM_FIELD_PIN = {
    id: 'pin',
    type: 'text',
    name: 'pin',
    placeholder: 'field.pinNumber.placeholder',
    label: 'field.pinNumber.label',
    inputMode: 'numeric'
};

export const FORM_SUBMIT_BUTTON = {
    id: 'linkWallet',
    type: 'button',
    action: 'submit',
    label: 'button.linkWallet',
    name: 'linkWallet'
};

export const FORM_VALIDATION_CONFIG = {
    pin: [
        required({
            error: 'playtech.mobile.wallet-linking.field.pinNumber.validation.required'
        }),
        regexp({
            re: '\\d{1,4}',
            error: 'playtech.mobile.wallet-linking.field.pinNumber.validation.regexp'
        }),
        length({
            max: 4,
            min: 4,
            error: 'playtech.mobile.wallet-linking.field.pinNumber.validation.length'
        })
    ]
};
